import { render, staticRenderFns } from "./FileCategories.vue?vue&type=template&id=51d4241e&"
import script from "./FileCategories.vue?vue&type=script&lang=js&"
export * from "./FileCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports